<template>
    <layout-basic>
        <v-container fluid>
            <v-row>
                <v-col md="12">
                    <v-card flat>
                        <v-card-actions>
                            <v-text-field
                            class="search-box"
                            placeholder="Search Playlists"
                            prepend-icon="fa-search"
                            v-model="search"
                            type="text"
                            clearable
                            clear-icon="fa-times"
                            @click:clear="resetSearch"
                            @change="applySearch"
                            ></v-text-field>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col md="12">
                    <v-card flat>
                        <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
                        <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
                        <v-data-table
                        :headers="headers"
                        :options.sync="options"
                        :server-items-length="serverItemsLength"
                        v-show="!loading"
                        :items="channels"
                        >
                            <template v-slot:item.icon="{ item }">
                                <i class="fa" :class="'fa-' + item.icon"></i>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </layout-basic>
</template>

<script>
    import PartnerAPI from "@/api/partner.js";
    import LayoutBasic from "@/layouts/PartnerHub";

    export default {
        name: "PlaylistReport",
        components: {
            LayoutBasic
        },
        data() {
            return {
                headers: [
                    { text: "Icon", value: "icon", sortable: false, align: "center" },
                    { text: "Playlist", value: "name" },
                    { text: "Assigned Users", value: "individual_users", sortable: false },
                    { text: "Assigned Groups", value: "total_groups", sortable: false },
                    { text: "Total Users", value: "total_users", sortable: false },
                    { text: "Modules", value: "total_modules", sortable: false },
                    { text: "Levels", value: "levels", sortable: false },
                ],
                channels: [],
                pagination: {},
                loading: false,
                options: {},
                search: "",
                searchParams: "",
                id: this.$route.params.id
            };
        },
        computed: {
            serverItemsLength: function() {
                return this.pagination.total;
            },
            itemsPerPage: function() {
                return this.pagination.per_page;
            },
            page: function() {
                return this.pagination.current_page;
            },
            params: function() {
                return this.$gf.getQueryString(this.options) + this.searchParams;
            },
            isTabletOrDesktop() {
                const width = this.$vuetify.breakpoint.width;
                return width >= 820;
            },
        },
        watch: {
            options: {
                handler() {
                    this.getChannels();
                },
                deep: true
            }
        },
        methods: {
            resetSearch() {
                this.options.page = 1;
                this.searchParams = "";
                this.getChannels();
            },
            applySearch() {
                this.options.page = 1;
                if (this.search != null) {
                    this.searchParams = this.params + "&search=name:" + this.search;
                } else {
                    this.searchParams = this.params;
                }
                this.getChannels();
            },
            getChannels() {
                this.loading = true;
                PartnerAPI.getChannels(this.params, this.id).then(resp => {
                    this.loading = false;
                    this.channels = resp.data.data;
                    this.pagination = resp.data.meta.pagination;
                });
            }
        }
    };
</script>
